import './banner.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Banner = ({ children }) => {
  return (
    <div className="banner">
      <div className="container">{children}</div>
    </div>
  );
};

Banner.propTypes = {
  children: PropTypes.node
};
export { Banner };
